export const RECOVERY_MESSAGE = 'If an eligible account matches that email, you will receive a password reset link. Check your inbox and spam folder.';

export async function requestPasswordRecovery({ baseUrl, email, signal, fetchImpl = fetch, timeoutMs = 15000 }) {
  const controller = new AbortController();
  const abort = () => controller.abort();
  signal?.addEventListener('abort', abort, { once: true });
  if (signal?.aborted) controller.abort();
  let timer;
  try {
    const result = await Promise.race([
      fetchImpl(`${baseUrl}/auth/password-reset/request`, {
        method: 'POST', credentials: 'omit', redirect: 'error',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim().toLowerCase() }),
        signal: controller.signal
      }).then(async response => {
        if (response.status === 429) throw new Error('Please wait a few minutes before requesting another reset link.');
        if (!response.ok) throw new Error('Password recovery is temporarily unavailable. Please try again later.');
        const body = await response.json().catch(() => null);
        if (body?.success !== true) throw new Error('Password recovery is temporarily unavailable. Please try again later.');
        return RECOVERY_MESSAGE;
      }),
      new Promise((_, reject) => { timer = setTimeout(() => { controller.abort(); reject(new Error('uncertain')); }, timeoutMs); })
    ]);
    return result;
  } catch (error) {
    if (error.message === 'uncertain' || error.name === 'AbortError' || error instanceof TypeError) {
      throw new Error('We could not confirm the request. A reset email may still arrive. Check your inbox before trying again.');
    }
    throw error;
  } finally {
    clearTimeout(timer);
    signal?.removeEventListener('abort', abort);
  }
}
